<script>
/**
 * Member UI component. Renders a nice member summary having image, name and description
 */
export default {
  props: {
    image: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
  methods: {
    excludeGiftlist() {
      
    }
  }
}
</script>
<template>
  <div>
    <div class="media mt-1 border-top pt-3">
      <img :src="`${image}`" class="avatar rounded-circle mr-3" alt="shreyu" />
      <div class="media-body">
        <h6 class="mt-1 mb-0 font-size-15"><b-link :href="'/lista/' + url">{{ name }}</b-link></h6>
        <h6 class="text-muted font-weight-normal mt-1 mb-3">{{ text }}</h6>
      </div>
      <b-dropdown
        variant="black"
        right
        toggle-class="arrow-none text-muted pr-0"
      >
        <template v-slot:button-content>
          Opções <i class="uil uil-cog"></i>
        </template>
        <b-dropdown-item :href="'/editarlista/' + url">
          <i class="uil uil-edit-alt mr-2"></i>Editar informações
        </b-dropdown-item>
        <b-dropdown-item  :href="'/adicionarprodutos/' + url">
          <i class="uil uil-plus-circle mr-2"></i>Adicionar produtos
        </b-dropdown-item>
        <b-dropdown-item  :href="'/editarprodutos/' + url">
          <i class="uil uil-cart mr-2"></i>Alterar produtos e quantidades
        </b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">
          <i class="uil uil-shopping-trolley mr-2"></i>Resgatar produtos
        </b-dropdown-item>
        <b-dropdown-item :href="'/lista/' + url">
          <i class="uil uil-share-alt mr-2"></i>Ver como convidado
        </b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">
          <i class="uil uil-bill mr-2"></i>Ver presentes
        </b-dropdown-item>
        <div class="dropdown-divider"></div>
        <!-- item-->
        <b-dropdown-item href="javascript:void(0);" variant="danger">
          <i class="uil uil-trash mr-2"></i>Excluir lista
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
